import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as Components from "../../../components";
import { FormContainer } from "../../ManagementPortal/Shared";
import {
  useCreateAreaMutation,
  useUpdateAreaMutation,
  useGetAreaQuery,
  useGetVendorsQuery,
} from "../services";
import { useForm } from "../../../hooks";
import { mergeObjects } from "../../../shared/helper";
import { removeAllTrailingBlanks } from "../../../shared/utility";

// Validation schema
const areaFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  code: Yup.string().required("Code is required"),
  vendor_id: Yup.number().required("Vendor is required"),
});

export const AreaForm = ({ id = null, showForm, setShowForm }) => {
  const { data: vendors = {} } = useGetVendorsQuery({ page: 0, per_page: 1000 });

  const [initialValues, setInitialValues] = useState({
    name: "",
    code: "",
    vendor_id: "",
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: areaFormSchema,
    onSubmit: (value) => handleFormSubmit(value),
  });

  const { data = {} } = useGetAreaQuery({ id }, { skip: !id });

  // Set form data in case of edit
  useEffect(() => {
    if (id && data) {
      setInitialValues(
        mergeObjects(initialValues, {
          name: data.name,
          code: data.code,
          vendor_id: data.vendor?.id || "",
        })
      );
    }
  }, [data]);

  const { create: createArea, update: updateArea } = useForm({
    createMutation: useCreateAreaMutation,
    updateMutation: useUpdateAreaMutation,
    closeForm: () => setShowForm(false),
    setError: formik.setErrors,
  });

  // handles form submit
  const handleFormSubmit = (formData) => {
    const cleanedFormData = removeAllTrailingBlanks(formData);
    if (id) {
      updateArea({ id, formData: cleanedFormData });
    } else {
      createArea({ formData: cleanedFormData });
    }
  };

  return (
    <FormContainer
      resourceName="Area"
      closeForm={() => setShowForm(false)}
      handleFormSubmit={formik.handleSubmit}
      idToEdit={id}
    >
      <Components.QIInput
        label="Area Name"
        {...formik.getFieldProps("name")}
        error={formik.touched.name && formik.errors.name}
      />

      <Components.QIInput
        label="Area Code"
        {...formik.getFieldProps("code")}
        error={formik.touched.code && formik.errors.code}
      />

      <Components.QICustomSelect
        label="Vendor"
        {...formik.getFieldProps("vendor_id")}
        onChange={(value) => formik.setFieldValue("vendor_id", value)}
        error={formik.touched.vendor_id && formik.errors.vendor_id}
      >
        <>
          <li value="">Select Vendor</li>
          {vendors?.data?.map((vendor) => (
            <li value={vendor.id} key={vendor.id}>
              {vendor.vendor_name}
            </li>
          ))}
        </>
      </Components.QICustomSelect>
    </FormContainer>
  );
};
